import React from "react";
import "./cart/CartItem-Style.css";
import { Link } from "react-router-dom";

const OrderShow = ({ item }) => {
  console.log(item);
  return (
    <div className="cartItem ORDER">
      <div className="details">
        <div className="image">
        <Link to={`/product/${item.product}`}>

          <img src={`/uploads/products/${item.id.pImages[0]}`} alt={item.title} />
          </Link>
        </div>
        <div className="desc">
          <Link to={`/product/${item._id}`}>
            <div className="title">{item.id.pName}</div>
          </Link>
          <div className="size">{item.id.pDescription}</div>
          <div className="price">₹{Math.floor(item.id.pPrice * (100 - item.id.pOffer) / 100)*item.quantity}</div>
        </div>
      </div>
      <div className="qty-row">
        <div className="qty">
          
          <div className="qty-value" style={{border:"none",width:100}}>Qty: {item.quantity}</div>
          
        </div>
        <div className="remove-btn">
          
        </div>
      </div>
    </div>
  );
};

export default OrderShow;
